import React from 'react';
import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import ValidationErrorText from '../common/ValidationErrorText';

const YesNoToggle = ({
  label = 'Select an option',
  value = 'yes',
  onChange = () => {},
  readOnly = false,
  trueLabel = 'Yes',
  falseLabel = 'No',
  sx = {},
  fieldError,
}) => {
  const toStr = (v) => {
    if (v === true || v === 'yes') return 'yes';
    if (v === false || v === 'no') return 'no';
    return null;
  };

  const fromStr = (s) => {
    if (typeof value === 'boolean') return s === 'yes';
    return s;
  };

  const selected = toStr(value);

  const handleToggle = (_e, newValue) => {
    if (newValue === null || readOnly) return;
    onChange(fromStr(newValue));
  };

  return (
    <div>
      {label && (
        <Typography fontSize="14px" fontWeight="500" my={1}>
          {label}
        </Typography>
      )}

      <ToggleButtonGroup
        value={selected}
        exclusive
        onChange={handleToggle}
        disabled={readOnly}
        sx={{
          mb: 2,
          display: 'flex',
          borderRadius: '30px',
          overflow: 'hidden',
          p: '2px',
          border: '1px solid #ccc',
          width: 'fit-content',
          ...sx,
        }}
      >
        <ToggleButton
          value="yes"
          sx={{
            flex: 1,
            px: 1,
            py: 0,
            fontSize: '13px',
            minWidth: 'auto',
            borderRadius: '30px !important',
            textTransform: 'none',
            fontWeight: 500,
            transition: '0.3s',
            border: 'none',
            '&.Mui-selected': {
              backgroundColor: '#1075FF',
              color: '#fff',
              '&:hover': { backgroundColor: '#1565c0' },
            },
          }}
        >
          {trueLabel}
        </ToggleButton>

        <ToggleButton
          value="no"
          sx={{
            flex: 1,
            px: 1,
            py: 0,
            fontSize: '13px',
            minWidth: 'auto',
            borderRadius: '30px !important',
            textTransform: 'none',
            fontWeight: 500,
            transition: '0.3s',
            border: 'none',
            '&.Mui-selected': {
              backgroundColor: '#1075FF',
              color: '#fff',
              '&:hover': { backgroundColor: '#1565c0' },
            },
          }}
        >
          {falseLabel}
        </ToggleButton>
      </ToggleButtonGroup>
      <ValidationErrorText error={fieldError}/>
      
    </div>
  );
};

export default YesNoToggle;
